import React from 'react';
import { Container, Box, Typography, Divider } from '@mui/material';

function PrivacyPolicy() {
  const primaryColor = '#800000';

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Header with Logo and Title */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box
          component="img"
          src="/create.png"
          alt="Company Logo"
          sx={{ width: 200, height: 'auto' }}
        />
        <Typography
          variant="h4"
          component="h1"
          sx={{ color: primaryColor, fontWeight: 600 }}
        >
          Privacy Statement
        </Typography>
      </Box>

      <Divider sx={{ borderColor: primaryColor, mb: 3 }} />

      {/* <Typography variant="body2" color="text.secondary" paragraph>
        Last updated: [Date]
      </Typography> */}

      <Typography variant="h6" sx={{ color: primaryColor, mt: 3, fontWeight: 600 }}>
        Government Agency Privacy Statement
      </Typography>
      <Typography paragraph>
        1. This is a Government of Singapore website.
      </Typography>

      <Typography paragraph>
        2. We may use “cookies”, which is defined as a small data file that is sent to your browser to store and track information about you as you enter our websites. The cookie is used to track information such as the number of users and their frequency of use, profiles of users and their preferred sites. While this cookie can tell us when you enter our sites and which pages you visit, it cannot read data off your hard disk.
      </Typography>

      <Typography paragraph>
        3. You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
      </Typography>

      <Typography paragraph>
        4. If you provide us with personally identifiable data,<br />
(a) We may share necessary data with other Government agencies, so as to serve you in the most efficient and effective way, unless such sharing is prohibited by law.<br />
(b) We will NOT share your Personal Data with non-Government entities, except where such entities have been authorised to carry out specific Government services.<br />
(c) For your convenience, we may also display to you data you had previously supplied us or other Government agencies.  This will speed up the transaction and save you the trouble of repeating previous submissions. Should the data be out-of-date, please supply us the latest data.  
      </Typography>

      <Typography paragraph>
        5. To safeguard your Personal Data, all electronic storage and transmission of Personal Data is secured with appropriate security technologies.
      </Typography>

      <Typography paragraph>
        6. This site may contain links to non-Government sites whose data protection and privacy practices may differ from ours.  We are not responsible for the content and privacy practices of these other websites and encourage you to consult the privacy notices of those sites.
      </Typography>

      <Typography paragraph>
        7. Please contact our Quality Service Manager (NRF_QSM@nrf.gov.sg) if you:<br />
(a) have any enquiries or feedback on our data protection policies and procedures,<br />
(b) need more information on or access to data which you have provided to us in the past.
      </Typography>

      

      

      {/* Add more sections as needed */}
    </Container>
  );
}

export default PrivacyPolicy;